import { render } from "./UserTask.vue?vue&type=template&id=0449334a&scoped=true"
import script from "./UserTask.vue?vue&type=script&lang=js"
export * from "./UserTask.vue?vue&type=script&lang=js"

import "./UserTask.vue?vue&type=style&index=0&id=0449334a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0449334a"

export default script